import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { useSuggestionsForNode } from '../../store/suggestions';
import type { DecisionNode, Suggestion } from '../../store/types';
import PatchCard from './primitives/patch-card';
type Props = {
  node: DecisionNode;
};
type PatchProps = {
  suggestion: Suggestion;
  node: DecisionNode;
};
const DecisionNodePatchCard = t0 => {
  const $ = _c(34);
  const {
    suggestion,
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.decision"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const op = suggestion.operation;
  const isStale = !suggestion.canApply;
  if (op.kind === "remove_node") {
    const t2 = suggestion.id;
    let t3;
    if ($[1] !== t) {
      t3 = t(_temp);
      $[1] = t;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== node.name || $[4] !== t) {
      t4 = t(_temp2, {
        name: node.name
      });
      $[3] = node.name;
      $[4] = t;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t4) {
      t5 = <p className="text-caption-3 text-tertiary">{t4}</p>;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== isStale || $[9] !== suggestion.id || $[10] !== t3 || $[11] !== t5) {
      t6 = <PatchCard suggestionId={t2} note={t3} isStale={isStale}>{t5}</PatchCard>;
      $[8] = isStale;
      $[9] = suggestion.id;
      $[10] = t3;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  if (op.kind === "update_node" && op.node.kind === "decision") {
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[13] !== isStale || $[14] !== op.node.questions || $[15] !== suggestion.id || $[16] !== t) {
      const keys = op.node.questions.map(_temp3).join(", ");
      T0 = PatchCard;
      t4 = suggestion.id;
      if ($[23] !== t) {
        t5 = t(_temp4);
        $[23] = t;
        $[24] = t5;
      } else {
        t5 = $[24];
      }
      t6 = isStale;
      t2 = "text-caption-3 text-tertiary";
      t3 = t(_temp5, {
        keys
      });
      $[13] = isStale;
      $[14] = op.node.questions;
      $[15] = suggestion.id;
      $[16] = t;
      $[17] = T0;
      $[18] = t2;
      $[19] = t3;
      $[20] = t4;
      $[21] = t5;
      $[22] = t6;
    } else {
      T0 = $[17];
      t2 = $[18];
      t3 = $[19];
      t4 = $[20];
      t5 = $[21];
      t6 = $[22];
    }
    let t7;
    if ($[25] !== t2 || $[26] !== t3) {
      t7 = <p className={t2}>{t3}</p>;
      $[25] = t2;
      $[26] = t3;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    let t8;
    if ($[28] !== T0 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7) {
      t8 = <T0 suggestionId={t4} note={t5} isStale={t6}>{t7}</T0>;
      $[28] = T0;
      $[29] = t4;
      $[30] = t5;
      $[31] = t6;
      $[32] = t7;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    return t8;
  }
  return null;
};

// Whole-node ops (remove / replace), rendered at the bottom of the node like the rules block.
const DecisionNodeSuggestions = t0 => {
  const $ = _c(7);
  const {
    node
  } = t0;
  const nodeSuggestions = useSuggestionsForNode(node.id);
  let t1;
  if ($[0] !== node || $[1] !== nodeSuggestions) {
    let t2;
    if ($[3] !== node) {
      t2 = suggestion => <DecisionNodePatchCard key={suggestion.id} suggestion={suggestion} node={node} />;
      $[3] = node;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = nodeSuggestions.map(t2);
    $[0] = node;
    $[1] = nodeSuggestions;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default DecisionNodeSuggestions;
function _temp($) {
  return $.remove;
}
function _temp2($_0) {
  return $_0.removeBody;
}
function _temp3(question) {
  return question.key;
}
function _temp4($_1) {
  return $_1.replace;
}
function _temp5($_2) {
  return $_2.replaceBody;
}